import { ComponentPropsWithoutRef } from 'react';
import { useDragLayer } from 'react-dnd';

import styled from '@mint-lib/styled';

import { dragItemTypes } from '../../../constants/myCampaigns.js';
import { Offset } from '../../../types/shared.js';
import { ChannelPlatformRow } from './ChannelPlatformRow.jsx';

export const DragLayerRow = () => {
  const { item, currentOffset, isDragging } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (
    !isDragging ||
    !currentOffset ||
    (item.type !== dragItemTypes.ADD_ROW &&
      item.type !== dragItemTypes.ADD_TILE)
  ) {
    return null;
  }

  return (
    <Layer>
      <CardStyled currentOffset={currentOffset}>
        <ChannelPlatformRow isDragged row={item} {...(item?.options || {})} />
      </CardStyled>
    </Layer>
  );
};

const Layer = styled('div')`
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  min-width: 120px;
  height: 100%;
  cursor: grab;
  border-radius: 4px;
`;

const CardStyled = styled(
  ({
    currentOffset,
    ...props
  }: ComponentPropsWithoutRef<'div'> & { currentOffset: Offset }) => (
    // @ts-ignore TODO: fix types
    <div style={{ top: currentOffset.y, left: currentOffset.x }} {...props} />
  ),
)`
  position: absolute;
  width: 330px;
  cursor: grabbing;
`;
